<template>
  <div class="philTableView" id="philTable">
    <div style="height: 100%">
      <slot name="header"></slot>
      <div class="header" :style="{ width: headerWidth }">
        <!-- <div class="header_item header_item-1">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
        </div> -->
        <div
          class="header_item header_item1"
          :style="{ width: setWidth(0) || '90px' }"
        >
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            v-if="showRadio"
          ></el-checkbox>
          <span style="padding-left: 10px">{{
            column && column.length ? column[0].label : '总序'
          }}</span>
        </div>
        <div
          class="header_item header_item5"
          :style="{ width: setWidth(1) || '80px' }"
        >
          {{ column && column.length ? column[1].label : '并行号' }}
        </div>
        <div
          class="header_item header_item4"
          :style="{ width: setWidth(2) || '120px' }"
        >
          {{ column && column.length ? column[2].label : '单位' }}
        </div>
        <div
          class="header_item header_item2"
          :style="{ width: setWidth(3) || '80px' }"
        >
          {{ column && column.length ? column[3].label : '分序' }}
        </div>
        <div class="header_item header_item3">
          <span style="font-weight: 600; font-size: 14px">{{
            column && column.length ? column[4].label : '操作内容'
          }}</span>
          <slot name="layout"></slot>
        </div>
      </div>
      <div class="body">
        <draggable
          v-model="tableList"
          :move="onMove"
          @end.stop="onEnd"
          animation="300"
          :disabled="true"
          ghostClass="ghostClass"
          chosenClass="chosenClass"
          filter=".forbid"
        >
          <el-checkbox-group
            v-model="checkedList"
            @change="handleCheckedCitiesChange"
          >
            <div
              v-resize="DomResize"
              class="tr"
              v-for="(item, index) in tableList"
              :key="index"
              @click.stop="($event) => rowClick(item, index, $event)"
              @contextmenu.stop="($event) => rightClick(item, index, $event)"
              :style="bgRandom ? setBgColor(item, index) : ''"
            >
              <div class="td" :style="setTdSelect(item, index)">
                <!-- <div class="td_item td_item-1">
                  <el-checkbox :label="index+1" :key="(index+1)"></el-checkbox>
                </div> -->
                <div
                  class="td_item td_item1"
                  :style="{ width: setWidth(0) || '90px' }"
                  style="font-size: 16px"
                >
                  <!-- <span>  {{ index+1 }}</span> -->
                  <el-checkbox
                    :label="index + 1"
                    :key="index + 1"
                    v-if="showRadio"
                  ></el-checkbox>
                  <span v-else style="width: 80%"> {{ index + 1 }}</span>
                  <div
                    class="cell-icon"
                    @click.stop="tableExpandClick(item, index)"
                    v-if="arrowShow"
                  >
                    <i class="el-icon-arrow-right" v-if="!item.expandShow"></i>
                    <i class="el-icon-arrow-down" v-if="item.expandShow"></i>
                  </div>
                </div>
                <div
                  class="td_item td_item5"
                  :style="{ width: setWidth(1) || '80px' }"
                  @click.stop="(e) => handleRowBXhclick(e, item, index)"
                >
                  <slot name="bxh" :row="item" :index="index"></slot>
                </div>
                <div
                  class="td_item td_item4"
                  :style="{ width: setWidth(2) || '120px' }"
                  @click.stop="(e) => handleRowNameclick(e, item, index)"
                  @dblclick.stop="
                    (e) => handleDoubleClickFxh(e, item, index, 'names')
                  "
                >
                  <slot name="depart" :row="item" :index="index"></slot>
                </div>
                <div
                  class="td_item td_item2"
                  style="font-size: 16px"
                  :style="{ width: setWidth(3) || '80px' }"
                  @dblclick.stop="
                    (e) => handleDoubleClickFxh(e, item, index, 'subIndex')
                  "
                >
                  {{ item.subIndex }}
                </div>
                <div
                  class="td_item td_item3"
                  @click.stop="(e) => handleRowDblclick(e, item, index)"
                  @dblclick.stop="
                    (e) => handleDoubleClickFxh(e, item, index, 'content')
                  "
                >
                  <slot name="content" :row="item"></slot>
                </div>
              </div>
              <div class="expand" v-if="item.expandShow">
                <div v-if="item.children && item.children.length">
                  <slot name="expand" :row="item"></slot>
                </div>
                <div style="padding: 20px; color: #c0c4cc" v-else>暂无操作</div>
              </div>
            </div>
          </el-checkbox-group>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  name: 'PhilTable',
  props: {
    sortableClass: {
      type: String,
      default: '',
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    column: {
      type: Array,
      default: () => [],
    },
    pointerEvents: {
      //控制table操作
      type: Boolean,
      default: false,
    },
    showRadio: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    radioIndex: {
      type: Number,
      default: null,
    },
    bgRandom: {
      //随机颜色
      type: Boolean,
      default: false,
    },
    rgbAndColor16: {
      //随机的颜色类型选择
      type: String,
      default: 'rgba',
    },
    transparent: {
      //随机的颜色透明度
      type: Number,
      default: 0.5,
    },
    arrowShow: {
      type: Boolean,
      default: true,
    },
    currentRowShowString: {
      //是否选中改变颜色
      type: String,
      default: '',
    },
  },
  directives: {
    resize: {
      // 指令的名称
      bind(el, binding) {
        // el为绑定的元素，binding为绑定给指令的对象
        // //console.log(el,"绑定",binding);
        let width = '',
          height = ''
        function isReize() {
          const style = document.defaultView.getComputedStyle(el)
          if (width !== style.width || height !== style.height) {
            binding.value({ width: style.width, height: style.height }) // 关键(这传入的是函数,所以执行此函数)
          }
          width = style.width
          height = style.height
        }
        el.__vueSetInterval__ = setInterval(isReize, 300)
      },
      unbind(el) {
        //console.log(el,"解绑");
        clearInterval(el.__vueSetInterval__)
      },
    },
  },
  components: {
    draggable,
  },
  data() {
    return {
      tableList: [],
      sortable: null,
      filterStr: '',
      headerWidth: '100%',
      isIndeterminate: false,
      checkAll: [],
      optionsAll: [],
      checkedList: [],
    }
  },
  watch: {
    tableData: {
      handler(val) {
        // //console.log('this.tableList',this.tableList)
        this.tableList = val
        if (val.length > 0 && this.sortableClass) {
          // this.rowDrop();
        }
        if (this.showRadio) {
          this.tableList.forEach((item) => {
            item.checked = false
          })
        }

        this.optionsAll = []
        this.tableList.forEach((item, index) => {
          this.optionsAll.push(index + 1)
        })
      },
      deep: true,
      immediate: true,
    },
    pointerEvents: {
      handler() {
        if (this.tableData.length > 0 && this.sortableClass) {
          // this.rowDrop();
        }
      },
      deep: true,
      immediate: true,
    },
    filter: {
      handler(val) {
        this.filterStr = val
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    // console.log('1111')
    // this.rowDrop();
  },
  onUpdated() {},
  methods: {
    onMove(e) {
      if (e.draggedContext.element.subIndex == '') return false
      if (e.relatedContext.element.subIndex == '') return false
      return true
    },
    onEnd(e) {
      //console.log('!this.pointerEvents',!this.pointerEvents)
      if (!this.pointerEvents) {
        if (this.tableData.length > 0 && this.sortableClass) {
          // //console.log('eeeee',e)
          // this.$emit("rowDrop",);
          this.$emit('rowDrop', {
            oldIndex: e.oldIndex,
            newIndex: e.newIndex,
            tableList: this.tableList,
          })
        }
      }
    },
    //展开行
    tableExpandClick(item, index) {
      // //console.log('index',index,item)
      if (this.tableList[index].expandShow) {
        this.tableList[index].expandShow = false
      } else {
        this.tableList[index].expandShow = true
      }
      this.$forceUpdate()
    },
    // 行单击 选中
    rowClick(row, index, event) {
      //  console.log(row,index, "row",event);
      event.stopPropagation()
      if (!this.pointerEvents) {
        this.$emit('rowClick', row, index)
      }
    },
    // 单元格双击点击
    handleRowDblclick(e, item, index) {
      //console.log('e.originalEvent.detail',e)
      e.stopPropagation()
      if (!this.pointerEvents) {
        //console.log('index',index)
        // this.$emit("rowClick",item,index);
        this.rowClick(item, index, e)
        this.$emit('handleRowDblclick', item, index)
      }
    },
    //分序号\操作单位\内容双击
    handleDoubleClickFxh(e, item, index, type) {
      if (!this.pointerEvents) {
        if (type === 'subIndex') {
          this.$emit('handleDoubleClickFxh', item, index)
        } else if (type === 'content') {
          this.$emit('handleDoubleClickContent', item, index)
        } else if (type === 'names') {
          this.$emit('handleDoubleClickNames', item, index)
        }
      }
    },
    handleRowNameclick(e, item, index) {
      e.stopPropagation()
      if (!this.pointerEvents) {
        // this.$emit("rowClick",item,index);
        this.rowClick(item, index, e)
        this.$emit('handleRowNameclick', item, index)
      }
    },
    // table的右键点击当前行事件
    rightClick(row, index, event) {
      // console.log('右击了吗', this.pointerEvents)
      if (!this.pointerEvents) {
        // this.rowClick(row, index, event)
        this.$emit('rightClick', row, index, event)
      }
    },
    fUpdate() {
      this.$forceUpdate()
    },
    //并行号点击
    handleRowBXhclick(e, item, index) {
      // e.stopPropagation ()
      if (!this.pointerEvents) {
        // this.$emit("rowClick",item,index);
        this.rowClick(item, index, e)
        this.$emit('handleRowBXhclick', item, index)
      }
    },
    DomResize(data) {
      let { width } = data
      // console.log("width:",width,"height:",height,"   dom尺寸方式改变");
      this.headerWidth = width
    },
    //全选
    handleCheckAllChange(val) {
      // console.log('val',val)
      this.checkedList = val ? this.optionsAll : []
      this.isIndeterminate = false
      this.$emit('rowChecked', this.checkedList)
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      // console.log('checkedCount',checkedCount,this.optionsAll)
      this.checkAll = checkedCount === this.optionsAll.length
      // console.log('checkedList',this.checkAll,this.checkedList)
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.optionsAll.length
      this.$emit('rowChecked', this.checkedList)
    },
    //设置随机色
    setBgColor(row) {
      // console.log('row', row)
      if (row.names) {
        let list = this.tableList.filter((x) => x.names === row.names)
        // let bgColor = this.color16()
        let bgColor =
          this.rgbAndColor16 === 'rgba'
            ? this.rgba(this.transparent)
            : this.color16()
        if (list.length > 1) {
          if (!this.tableList[list[0].index].background) {
            this.tableList[list[0].index].background = bgColor
          }
        } else {
          if (!this.tableList[list[0].index].background) {
            this.tableList[list[0].index].background = bgColor
          }
        }
        return { background: this.tableList[list[0].index].background }
      }
      return { background: '#fff' }
    },
    color16() {
      //十六进制颜色随机
      const r = Math.floor(Math.random() * 256)
      const g = Math.floor(Math.random() * 256)
      const b = Math.floor(Math.random() * 256)
      const color = `#${r.toString(16)}${g.toString(16)}${b.toString(16)}`
      return color
    },
    rgba(num) {
      //rgb颜色随机
      const r = Math.floor(Math.random() * 256)
      const g = Math.floor(Math.random() * 256)
      const b = Math.floor(Math.random() * 256)
      return `rgb(${r},${g},${b},${num})`
    },
    //选中效果
    setCurrentRow() {},
    //设置选中效果
    setTdSelect(item, index) {
      if (this.currentRowShowString) {
        if (this.checkedList.length) {
          let obj = null
          this.checkedList.forEach((num) => {
            if (num - 1 === index) {
              obj = {
                background: `${this.currentRowShowString} !important`,
              }
            }
          })

          return obj
        }
      }
      return ''
    },
    //取消选中效果
    removeAllCurrentRow() {
      this.checkedList = []
    },
    //设置宽度
    setWidth(num) {
      if (this.column && this.column.length) {
        return this.column[num].width
      } else {
        return ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-checkbox-group {
  font-size: 16px;
}
.chosenClass {
  background: none !important;
}
.ghostClass {
  background: none !important;
}
.philTableView {
  height: 100%;
  .header {
    display: flex;
    align-items: center;
    color: #909399;
    font-size: 14px;
    position: sticky;
    top: 0;
    z-index: 990;
    .header_item {
      background: #e5e5e5;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      border-left: 1px solid #b3b3b3;
      color: #000;
      font-weight: 600;
    }
    .header_item:first-child {
      border-left: none;
    }
    .header_item-1 {
      width: 40px;
    }
    .header_item1 {
      width: 90px;
      justify-content: left;
      padding: 0 6px 0px 15px;
      span {
        color: #000;
        font-weight: 600;
      }
    }
    .header_item2 {
      width: 80px;
    }
    .header_item3 {
      flex: 1;
      justify-content: space-between;
      padding-left: 6px;
      padding-right: 6px;
      min-width: 110px;
    }
    .header_item4 {
      width: 120px;
    }
    .header_item5 {
      width: 80px;
    }
  }
  .body {
    width: 100%;
    height: calc(100% - 36px);
    overflow: auto;
    .radioClass > div {
      background-color: #d2e2f5;
    }
    .tr {
      width: 100%;
      background-color: #fff;
      border-bottom: 1px solid #d0d0d0;
      .td {
        width: 100%;
        display: flex;
        // align-items: center;
        min-height: 48px;
        .td_item {
          // height: 48px;
          // height:inherit;//改变
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          position: relative;
          border-left: 1px solid #b3b3b3;
          // overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          font-size: 14px;
          padding-left: 6px;
          padding-right: 6px;
        }
        .td_item:first-child {
          border-left: none;
        }
        .td_item-1 {
          width: 40px;
        }
        .td_item1 {
          width: 90px;
          justify-content: space-between;
          padding: 0 6px 0px 15px;
          align-items: center;
          flex-wrap: wrap;
        }
        .td_item2 {
          width: 80px;
        }
        .td_item3 {
          flex: 1;
          justify-content: left;
          min-width: 110px;
        }
        .td_item4 {
          width: 120px;
        }
        .td_item5 {
          width: 80px;
        }
      }
    }
    .tr:nth-child(2n) {
      // background: #F4F5F7;
    }
    .td:hover {
      color: #409eff;
      // background: #ecf5ff;
      // background-color: rgb(245, 247, 250);
      border-color: #b3d8ff;
    }
    .td:hover .td_item1 /deep/.el-checkbox__label {
      color: #409eff;
    }
    .cell-icon {
      margin-left: 2px;
      // position: absolute;
      // right: 10px;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
